import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  yourReports: [
    {
      title: "List of products of aroha",
      terminal: ["Intl Airside", "Intl Landside", "Domestic"],
      store: ["Aroha"],
    },
    {
      title: "List of products of hudson",
      terminal: ["Intl Airside", "Intl Landside", "Domestic"],
      store: ["Hudson"],
    },
    {
      title: "List of products of allpress cafe",
      terminal: ["Intl Airside", "Intl Landside", "Domestic"],
      store: ["Allpress Cafe"],
    },
  ],
};

const yourReportsSlice = createSlice({
  name: "yourReports",
  initialState,
  reducers: {
    addReport: (state, action) => {
      state.yourReports.push(action.payload);
    },
    updateReport: (state, action) => {
      const { index, report } = action.payload;
      state.yourReports[index] = report;
    },
    removeReport: (state, action) => {
      const { reportIndex } = action.payload;
      const newState = state.yourReports.filter((_, i) => i != reportIndex);
      state.yourReports = newState;
    },
  },
});

export const { addReport, updateReport, removeReport } =
  yourReportsSlice.actions;

export default yourReportsSlice.reducer;
